import { GenericFetchHookParamsType } from '../contextFetch'
import {
  fetchData,
  fetchDataNull,
  useSWRWithCache,
  FetchHandlerType
} from '../swr'
import getAPIDomain from '@signal/utils/env/apiDomain'
import { useMemo } from 'react'
import { AccountSearchResponseType } from './types'
import { encodeGuidsToString } from './utils'

export const MINIMUM_TERM_LENGTH = 3

export interface UseAccountSearchHookParamsType
  extends GenericFetchHookParamsType {
  mockData?: AccountSearchResponseType
  searchableAccountIds: Array<string>
  term: string
}

export function getAccountSearchPath(term: string): string {
  const encodedTerm = encodeURIComponent(term || 'x')
  return `${getAPIDomain()}/accounts/info/v4/search/filter-accounts/${encodedTerm}/`
}

export function useAccountSearch({
  searchableAccountIds,
  term,
  mockData,
  useMockData,
  ...rest
}: UseAccountSearchHookParamsType): AccountSearchResponseType | undefined {
  const url = useMemo(() => getAccountSearchPath(term), [term])
  return (
    useSWRWithCache<AccountSearchResponseType, string>({
      context: 'useAccountSearch',
      body: encodeGuidsToString(searchableAccountIds),
      fetchHandler: (term && term.length >= MINIMUM_TERM_LENGTH
        ? fetchData
        : fetchDataNull) as FetchHandlerType<AccountSearchResponseType>,
      method: 'POST',
      url,
      ...rest
    }) || (useMockData ? mockData : undefined)
  )
}
